class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();
    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.secondLevel = this.el.querySelector('.drawer-submenu__panel');
    this.thirdLevel = this.el.querySelector('.drawer-subsubmenu__panel');
    this.headerMenu = document.querySelectorAll('.header-shortlink');
    this.announcementBar = document.querySelectorAll('.announcements-bar');
    this.DesktopHeaderMenu = document.querySelectorAll('#MainHeader');
    this.emptyPanels = document.querySelectorAll('.drawer-banner-panel')
    this.init();
  }
  
  init() {
    //toggle first level menu
    this.firstLevelMenu = this.el.querySelectorAll('.first_level');
    this.headerMenu.forEach((main) => { 
      main.addEventListener('click', this.headerMenuClick.bind(this));
    });

    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

  // These toggle subsubmenu panel
    this.secondLevelItemsWithChildren = this.el.querySelectorAll('.drawer-submenu__item__input');
    this.secondLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

  // These toggle subsubsubmenu panel
    this.secondLevelButton = this.el.querySelectorAll('.drawer-submenu__item')
    this.secondLevelButton.forEach((btn) => {
      btn.addEventListener('click', this.openThirdLevel.bind(this) );
    });


    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });

  }

// handle first level menu to show only clicked menu elements
  headerMenuClick(event, skipEl) {
    const menus = event.currentTarget || scope;
    this.firstLevelMenu.forEach((chkMenu) => { 
      let clean_string = menus.innerText.replace(/\s/g, '')
      if (chkMenu.classList.contains(clean_string)){
        chkMenu.classList.remove("hide")
        }
      else {
        chkMenu.classList.add("hide")
      }
      });
   
    // header menu transform in desktop
    this.DesktopHeaderMenu.forEach((chkMenu) => { 
      chkMenu.classList.add("headerMenuAlt")
    });

    this.announcementBar.forEach((chkMenu) => { 
      chkMenu.classList.add("hide")
    });

    this.emptyPanels.forEach((chkMenu) => { 
      //console.log("nodes " + chkMenu.childNodes.length)
      if (chkMenu.childNodes.length <= 1) {
      //console.log("from panels " + chkMenu.innerText + chkMenu.childNodes.length)
      chkMenu.classList.add("hide")
      } else {
        chkMenu.classList.remove("hide")
      }
    });

  }

  closeAllItems(event, skipEl) {
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) {
        return;
      }
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      const secondAccordion = this.secondLevel.closest('[data-accordion-item]')
      console.log("second accord" + secondAccordion.classList)
      if (accordion || secondAccordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          if (accordion) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
          } else {
          const subParent = secondAccordion.closest('.drawer-menu__contents')
          subParent.classList.remove('pull-left');
          }
        }
      }
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');

             //header menu to normal
             this.DesktopHeaderMenu.forEach((chkMenu) => { 
               chkMenu.classList.remove("headerMenuAlt")
             });
     
             this.announcementBar.forEach((chkMenu) => { 
               chkMenu.classList.remove("hide")
             });
    }

  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    const secondAccordion = this.secondLevel.closest('[data-accordion-item]')
    if (!accordion || !secondAccordion) {
      return;
    }
    if (screen.width <= 820) {
      if (accordion) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
      }
      else {
      const subParent = secondAccordion.closest('.drawer-submenu__panel')
      subParent.classList.toggle('pull-left');
      }
    }

    accordion.classList.toggle('is-open');
    secondAccordion.classList.toggle('is-open')
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
    if (secondAccordion.classList.contains('is-open')) {
      this.secondLevel.classList.add('has-open-submenu')
    }else {
      this.secondLevel.classList.remove('has-open-submenu')
    }
  }
  
  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    this.closeAllItems();

    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    input.focus();
  }

  openThirdLevel(event, skipEl) {
    console.log("click")
    this.secondLevelButton = this.el.querySelectorAll('.drawer-submenu__item')
   /* this.secondLevelButton.forEach((btn) => {
      console.log(btn.classList)
      if (btn.classList.contains('--drilldown')) {
        this.thirdLevel.classList.add("testeross")
        console.log("it's open")
      }
    });*/
  }

}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}
